import { Component, Input } from '@angular/core';

import { ClaimRequestService } from '../../../services/claim.request.service';
import { lastValueFrom } from 'rxjs/internal/lastValueFrom';
import { ActivatedRoute, Router } from '@angular/router';
import { RateClaimRequestDto } from '../../../../../core/data/dtos/rate.claim.request.dto';
import { SwalService } from '../../../../../common/services/swal.service';
import { FormsModule } from '@angular/forms';
import { PlatformsService } from '../../../../../core/data/services/platforms.service';


@Component({
  selector: 'app-claim-request-rate',
  imports: [FormsModule],
  providers: [ClaimRequestService, SwalService],
  templateUrl: './claim-request-rate.component.html',
  styleUrl: './claim-request-rate.component.css'
})
export class ClaimRequestRateComponent {
  @Input() claimRequestId?: number;
  stars: number[] = [1, 2, 3, 4, 5];
  selectedRating: number = 5;
  comment: string = String();

  constructor(
    private claimRequestService: ClaimRequestService,
    private swalService: SwalService,
    private router: Router,
    private route: ActivatedRoute,
    private platformService: PlatformsService,
  ) { }

  selectRating(rating: number) {
    this.selectedRating = rating;
  }

  async rateClaim() {
    this.swalService.showLoading('Calificando servicio');
    try {
      const request: RateClaimRequestDto = {
        claimsRequestId: this.claimRequestId,
        rate: this.selectedRating,
        note: this.comment || String(),
      };
      await lastValueFrom(this.claimRequestService.rateClaimRequest(request));
    } catch (e) { }
    this.swalService.dismiss();
    const client = this.route.snapshot.queryParamMap.get('client');

    if (this.platformService.isIOs() || this.platformService.isEmbeddedApp()) {
      if (client) {
        this.router.navigateByUrl(`/claim-requests/${client}`, { replaceUrl: true });
        return;
      }
      // No client param: would bounce to an MSAL-protected route in the
      // native webview. Go back instead.
      window.history.back();
      return;
    }

    this.router.navigate(['/claim-request']);
  }
}
